import React, { Component } from "react";
import Classnames from "classnames";
import Day from "dayjs";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

import { MAP_HERO_EN_CN } from "@/utils/getting";
import { RoundNum } from "@/utils/setting";
import Store from "@/stores";

@observer
class Summary extends Component {
	static propTypes = { _ladderStore: PropTypes.object }
	static defaultProps = { _ladderStore: {} }
	state = {
		hero: "",
		index: 0,
		isShow: false,
		level: 0,
		ratio: "0%"
	}
	render() {
		const { heroes, kills, lastUpdated, paragonLevel, paragonLevelHardcore, timePlayed } = Store._ladderStore.target;
		const { elites, monsters } = kills;
		const { hero, index, isShow, level, ratio } = this.state;
		return (
			<div className="ladder-summary fr pr">
				<ul className="total">
					<li>
						<p>{monsters}</p>
						<small>怪物消灭数</small>
					</li>
					<li>
						<p>{elites}</p>
						<small>精英怪消灭数</small>
					</li>
					<li>
						<p>{paragonLevel} | <span>{paragonLevelHardcore || 0}</span></p>
						<small>巅峰等级</small>
					</li>
				</ul>
				<h5>各职业的游戏时间</h5>
				<div className="ratio pr">
					<div className={Classnames("tips pa", { active: isShow })} style={{ left: (index + 1) * 35 + "px" }}>
						<p>{MAP_HERO_EN_CN[hero]}</p>
						<span>{ratio}</span>
						<span>最高等级：{level}</span>
					</div>
					<ul className="clearfix center">{this.sortHero(timePlayed, heroes)}</ul>
					<p className="clearfix center">
						<span>野蛮人</span>
						<span>圣教军</span>
						<span>猎魔人</span>
						<span>武僧</span>
						<span>死灵法师</span>
						<span>巫医</span>
						<span>魔法师</span>
					</p>
				</div>
				<h6>最近更新于 {Day(lastUpdated * 1000).format("YYYY-MM-DD HH:mm:ss")}</h6>
			</div>
		);
	}
	sortHero(ratio, hero) {
		const total = Object.values(ratio).reduce((t, c) => t + c, 0);
		const { barbarian, crusader, "demon-hunter": demonhunter, monk, necromancer, "witch-doctor": witchdoctor, wizard } = ratio;
		const level = this.sortLevel(hero);
		const map = [
			{ hero: "barbarian", level: level["野蛮人"] || 0, num: barbarian || 0 },
			{ hero: "crusader", level: level["圣教军"] || 0, num: crusader || 0 },
			{ hero: "demon-hunter", level: level["猎魔人"] || 0, num: demonhunter || 0 },
			{ hero: "monk", level: level["武僧"] || 0, num: monk || 0 },
			{ hero: "necromancer", level: level["死灵法师"] || 0, num: necromancer || 0 },
			{ hero: "witch-doctor", level: level["巫医"] || 0, num: witchdoctor || 0 },
			{ hero: "wizard", level: level["魔法师"] || 0, num: wizard || 0 }
		];
		return map.map((v, i) => {
			v.ratio = RoundNum(v.num / total, 0, true);
			return (
				<li
					key={v.hero}
					onMouseEnter={this.setInfo.bind(this, Object.assign({}, v, { index: i }))}
					onMouseLeave={this.setInfo.bind(this, null)}
				>
					<em style={{ height: RoundNum(v.num, 0, true) }} />
				</li>
			);
		});
	}
	sortLevel(list) {
		const obj = toJS(list).reduce((t, c) => {
			if (t[c.class] && t[c.class].length) {
				t[c.class].push(c);
			} else {
				t[c.class] = [];
				t[c.class].push(c);
			}
			return t;
		}, {});
		for (const k in obj) {
			obj[k] = obj[k].sort((a, b) => a.level < b.level ? 1 : -1)[0].level;
		}
		return obj;
	}
	setInfo(v) {
		if (v) {
			this.setState({
				hero: v.hero,
				index: v.index,
				isShow: true,
				level: v.level,
				ratio: v.ratio
			});
		} else {
			this.setState({
				hero: "",
				index: 0,
				isShow: false,
				level: 0,
				ratio: "0%"
			});
		}
	}
}
export default Summary;